/* eslint-disable no-underscore-dangle */
import videojs from 'video.js';

import { setVideoSetting } from 'src/helpers/videoSetting';

const MenuItem = videojs.getComponent('MenuItem');

export class QualityControlItem extends MenuItem {
  private itemOptions: { label: string; url: string };

  private onItemClick: (item: QualityControlItem, label: string) => void;

  constructor(player: videojs.Player, options: any, onItemClick: (item: QualityControlItem, label: string) => void) {
    super(player, options);
    this.itemOptions = options;
    this.onItemClick = onItemClick;
  }

  handleClick(event: videojs.EventTarget.Event): void {
    super.handleClick(event);
    if (this.itemOptions.url === this.player_.src()) return;
    this.onItemClick(this, this.itemOptions.label);
    const currentTime = this.player_.currentTime();
    const playbackRate = this.player_.playbackRate();
    const volume = this.player_.volume();
    const autoplay = this.player_.autoplay() || false;
    const isPaused = this.player_.paused();
    const isMuted = this.player_.muted();

    setVideoSetting({
      volume,
      playbackRate,
      isMuted,
      quality: this.itemOptions.label,
    });

    const restorePlayerState = () => {
      this.player_.currentTime(currentTime);
      if (isPaused && !autoplay) {
        this.player_.pause();
      }
      this.player_.playbackRate(playbackRate || 1);
      this.player_.volume(volume);
      this.player_.muted(isMuted);
    };

    this.player_.src({
      src: this.itemOptions.url,
    });

    this.player_.ready(() => {
      if (this.player_.readyState() < 3) {
        this.player_.one('canplay', restorePlayerState);
      } else {
        restorePlayerState();
      }
    });
  }
}
